import { Controller } from "@hotwired/stimulus";
import { useStore } from "stimulus-store";
import { allBundlesStore } from "../../../stores/device_types/all_bundles_store";
import { sendFailureNotification, sendSuccessNotification } from "shared/toast_notifications";
import { getCsrfToken } from "shared/form_helpers";
import { bundleStore } from "../../../stores/device_types/bundle_store";

// Connects to data-controller="forms--bundle--delete-bundle-form"
export default class extends Controller {

    static stores = [
        allBundlesStore,
        bundleStore
    ]

    static targets = [
        'form',
        'bundleSelect',
        'confirmButton'
    ];

    connect() {
        useStore(this);

        // Prevent default form submission
        if (this.hasFormTarget) {
            this.formTarget.addEventListener('submit', (e) => e.preventDefault());
        }
    }

    async delete(event) {
        event.preventDefault();

        // Get the selected bundle
        const bundle = this.bundleStoreValue;
        if (!bundle || !bundle.id) {
            sendFailureNotification('Please select a bundle to delete.');
            return;
        }

        // Disable confirm button to prevent double submission
        if (this.hasConfirmButtonTarget) {
            this.confirmButtonTarget.disabled = true;
        }

        try {
            // Make API request
            const response = await fetch('/api/device_types/bundle/delete', {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': getCsrfToken()
                },
                body: JSON.stringify({
                    id: bundle.id,
                    name: bundle.name
                })
            });

            const result = await response.json();

            if (response.ok && result.status === 'success') {
                // Show success notification
                sendSuccessNotification(`Successfully deleted the ${ bundle.name } bundle`);

                // Remove bundle from the store
                const currentBundles = this.allBundlesStoreValue || [];
                const updatedBundles = currentBundles.filter(b => b.id !== bundle.id);
                this.setAllBundlesStoreValue(updatedBundles);

                // Clear the current bundle store
                this.setBundleStoreValue({});

                // Clear the bundle select dropdown
                if (this.hasBundleSelectTarget && this.bundleSelectTarget.tomselect) {
                    this.bundleSelectTarget.tomselect.clear();
                }
            } else {
                // Show error notification
                const errorMessage = result.message || 'Failed to delete bundle. Please try again.';
                sendFailureNotification(errorMessage);
            }
        } catch (error) {
            console.error('Error deleting bundle:', error);
            sendFailureNotification('An error occurred while deleting the bundle. Please try again.');
        } finally {
            // Re-enable confirm button
            if (this.hasConfirmButtonTarget) {
                this.confirmButtonTarget.disabled = false;
            }
        }
    }
}